// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"07d8938f","828":"ac370772","851":"59466e1d"}[chunkId] + ".chunk.js";
};